<div class="fdk-checkbox">
  <input
    class="fdk-checkbox__control"
    [checked]="checked"
    [disabled]="disabled"
    [indeterminate]="indeterminate"
    [attr.aria-labelledby]="contentId"
    [id]="checkboxId"
    [value]="value"
    type="checkbox" />

  <div
    class="fdk-checkbox__content"
    [id]="contentId">
    <ng-content />
  </div>
</div>
